import React from 'react';
import { Share2, Heart, Languages } from 'lucide-react';

type QuoteActionsProps = {
  isLiked: boolean;
  onLike: () => void;
  onShare: () => void;
  onTranslate: () => void;
  isTranslating: boolean;
  isTranslated: boolean;
};

const QuoteActions: React.FC<QuoteActionsProps> = ({ 
  isLiked, 
  onLike, 
  onShare, 
  onTranslate, 
  isTranslating,
  isTranslated
}) => {
  return (
    <div className="flex justify-between items-center mt-4">
      <div className="flex space-x-2">
        <button
          onClick={onShare}
          className="p-2 rounded-full transition-colors duration-200 bg-gray-200 text-gray-600 hover:bg-blue-500 hover:text-white"
          title="Share Quote"
        >
          <Share2 size={20} />
        </button>
        <button
          onClick={onTranslate}
          className={`p-2 rounded-full transition-colors duration-200 ${
            isTranslated ? 'bg-green-500 text-white' : 'bg-gray-200 text-gray-600'
          } hover:bg-green-600 hover:text-white`}
          title={isTranslated ? "Show Original" : "Translate Quote"}
          disabled={isTranslating}
        >
          <Languages size={20} />
        </button>
      </div>
      <button
        onClick={onLike}
        className={`p-2 rounded-full transition-colors duration-200 ${
          isLiked ? 'bg-red-500 text-white' : 'bg-gray-200 text-gray-600'
        } hover:bg-red-600 hover:text-white`}
        title={isLiked ? "Unlike" : "Like"}
      >
        <Heart size={20} fill={isLiked ? "white" : "none"} />
      </button>
    </div>
  );
};

export default QuoteActions;